/* La Boutique · capa interactiva (subida por API · interactivo.py) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WA = '34655881489';
  var d = document, root = d.documentElement;
  root.classList.add('lb-js');

  /* 1 · Aparición al hacer scroll (con escalonado dentro de cada rejilla) */
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = 'main .resource-list--grid > .resource-list__item, main .image-block, main .hero, main .section-resource-list__header, main .media-with-content';
    var els = [].slice.call(d.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('.lb-rv') && !el.closest('[class*="carousel"], slideshow-component, .product-information')
        && el.getBoundingClientRect().top > window.innerHeight * 0.9;
    });
    setTimeout(function () {   /* red de seguridad: nada se queda invisible */
      els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('lb-in'); });
    }, 2500);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, sib = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
        el.style.transitionDelay = Math.min(sib, 6) * 70 + 'ms';
        el.classList.add('lb-in'); io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.classList.add('lb-rv'); io.observe(el); });
  }

  /* 2 · Zoom lento de la foto de portada + 3 · parallax suave en banners (solo escritorio) */
  function motion() {
    if (reduce) return;
    var first = d.querySelector('main .hero img');
    if (first) first.classList.add('lb-kenburns');
    if (window.innerWidth < 900) return;
    var imgs = [].slice.call(d.querySelectorAll('main .hero img')).slice(1);
    var tick = false;
    function upd() {
      tick = false;
      var vh = window.innerHeight;
      imgs.forEach(function (im) {
        var r = im.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;       // -1..1
        im.style.transform = 'scale(1.06) translate3d(0,' + (p * -18).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* 4 · Botón flotante de WhatsApp: aparece al bajar; en ficha pregunta por ESE producto */
  function whatsapp() {
    var h1 = d.querySelector('main h1');
    var enFicha = /\/products\//.test(location.pathname) && h1;
    var msg = enFicha ? 'Hola, me interesa «' + h1.textContent.trim() + '». ¿Me decís qué talla me iría bien?'
                      : 'Hola, tengo una duda sobre la tienda online';
    var a = d.createElement('a');
    a.className = 'lb-wa'; a.target = '_blank'; a.rel = 'noopener';
    a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
    a.setAttribute('aria-label', 'Escríbenos por WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 32 32" width="26" height="26" aria-hidden="true"><path fill="currentColor" d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.33.67 4.5 1.84 6.35L4 29l7.9-1.8a12.1 12.1 0 0 0 4.14.72C22.68 27.92 28 22.56 28 15.95 28 9.34 22.68 3 16.04 3zm0 22.73c-1.3 0-2.58-.26-3.76-.76l-.27-.11-4.69 1.07 1.1-4.52-.18-.29a9.66 9.66 0 0 1-1.55-5.15c0-5.4 4.4-9.8 9.35-9.8 5.28 0 9.63 4.4 9.63 9.8 0 5.41-4.35 9.76-9.63 9.76zm5.28-7.3c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.66.14-.19.29-.76.94-.93 1.13-.17.2-.34.22-.63.08-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.59.13-.13.29-.34.44-.51.14-.17.19-.29.29-.49.1-.19.05-.36-.02-.51-.08-.15-.66-1.58-.9-2.16-.24-.57-.48-.49-.66-.5h-.56c-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.43 0 1.43 1.05 2.82 1.19 3.01.15.2 2.06 3.15 5 4.41.7.3 1.24.48 1.67.62.7.22 1.34.19 1.84.12.56-.08 1.72-.7 1.97-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.56-.34z"/></svg><span>¿Dudas? Escríbenos</span>';
    d.body.appendChild(a);
    var mostrar = function () { a.classList.toggle('lb-wa--on', window.scrollY > 380 || enFicha); };
    window.addEventListener('scroll', mostrar, { passive: true }); mostrar();
    /* en ficha no tapa «Agregar al carrito» (móvil): se esconde mientras ese botón está a la vista */
    var add = enFicha && d.querySelector('main form[action*="/cart/add"] button[type="submit"], main button[name="add"]');
    if (add && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { a.classList.toggle('lb-wa--tapa', es[0].isIntersecting); }).observe(add);
    }
  }

  /* 5 · Barra fija de compra en móvil cuando el botón real sale de pantalla */
  function barraCompra() {
    if (!/\/products\//.test(location.pathname)) return;
    var btn = d.querySelector('main form[action*="/cart/add"] button[type="submit"], main button[name="add"]');
    var h1 = d.querySelector('main h1');
    if (!btn || !h1 || !('IntersectionObserver' in window)) return;
    var precio = d.querySelector('main .price, main product-price');
    var bar = d.createElement('div');
    bar.className = 'lb-buybar';
    bar.innerHTML = '<div class="lb-buybar__txt"><strong></strong><span></span></div><button type="button" class="button">Añadir</button>';
    bar.querySelector('strong').textContent = h1.textContent.trim();
    var syncPrecio = function () { bar.querySelector('span').textContent = precio ? precio.textContent.replace(/\s+/g, ' ').trim() : ''; };
    syncPrecio();
    bar.querySelector('button').addEventListener('click', function () {
      btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { btn.click(); }, reduce ? 0 : 450);
    });
    d.body.appendChild(bar);
    new IntersectionObserver(function (es) {
      var fuera = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.classList.toggle('lb-buybar--on', fuera); syncPrecio();
      d.body.classList.toggle('lb-has-buybar', fuera);
    }).observe(btn);
  }

  /* 6 · Nota de confianza bajo el total del carrito (también cuando el carrito se repinta) */
  function notaCarrito() {
    var poner = function () {
      d.querySelectorAll('.cart-totals__tax-note').forEach(function (n) {
        if (n.parentElement.querySelector('.lb-nota')) return;
        var x = d.createElement('div'); x.className = 'lb-nota';
        x.innerHTML = '<span>✓ Recogida gratis en La Algaba</span><span>✓ Te avisamos por WhatsApp cuando esté listo</span><span>✓ Te ayudamos con la talla antes de pedir</span>';
        n.insertAdjacentElement('afterend', x);
      });
    };
    poner(); new MutationObserver(poner).observe(d.body, { childList: true, subtree: true });
  }

  /* 7 · Carrito: «Eliminar» nunca se pierde. El tema bloquea el carrito mientras guarda un cambio, así que un
        segundo toque rápido no hacía nada. Aquí ese toque se apunta (por la clave de la línea, no por su posición)
        y se lanza en cuanto el carrito vuelve a estar libre. */
  function colaEliminar() {
    var cola = [];
    root.classList.add('lb-cola');
    var fila = function (el) { return el.closest('.cart-items__table-row'); };
    window.addEventListener('click', function (e) {
      var b = e.target instanceof Element ? e.target.closest('.cart-items__remove') : null;
      if (!b) return;
      var f = fila(b), ocupado = b.closest('.cart-items-disabled');
      if (!ocupado && !(f && f.classList.contains('removing'))) return;   /* carrito libre: lo gestiona el tema */
      e.preventDefault(); e.stopImmediatePropagation();
      var clave = f && f.dataset.key;
      if (!clave || f.classList.contains('removing') || cola.indexOf(clave) > -1) return;
      cola.push(clave); f.classList.add('lb-quitando');
    }, true);
    var vaciar = function () {
      if (!cola.length || d.querySelector('.cart-items-disabled')) return;
      var clave = cola.shift(), hecho = false;
      d.querySelectorAll('.cart-items__table-row').forEach(function (f) {
        if (hecho || f.dataset.key !== clave || f.classList.contains('removing')) return;
        var b = f.querySelector('.cart-items__remove');
        if (b && f.offsetParent !== null) { hecho = true; b.click(); }
      });
      if (!hecho) vaciar();
    };
    new MutationObserver(function () {
      cola.forEach(function (clave) {      /* el repintado quita la marca: se vuelve a poner */
        d.querySelectorAll('.cart-items__table-row').forEach(function (f) { if (f.dataset.key === clave && !f.classList.contains('lb-quitando')) f.classList.add('lb-quitando'); });
      });
      setTimeout(vaciar, 0);
    }).observe(d.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  /* 8 · Colores en español. Shopify guarda en inglés los colores «estándar» que elige Tere al crear el producto
        (Black, Gray, Brown…) y por API no se pueden renombrar; aquí se muestran traducidos en ficha, tarjetas y carrito.
        (En la página de pago siguen en inglés hasta que se cambien en Contenido → Metaobjetos → Color.) */
  function coloresES() {
    var ES = { Black: 'Negro', Gray: 'Gris', Grey: 'Gris', Brown: 'Marrón', White: 'Blanco', Red: 'Rojo', Blue: 'Azul',
      Green: 'Verde', Pink: 'Rosa', Yellow: 'Amarillo', Orange: 'Naranja', Purple: 'Morado', Navy: 'Marino',
      Gold: 'Dorado', Silver: 'Plateado', Bronze: 'Bronce', Clear: 'Transparente', 'Rose gold': 'Oro rosa' };
    var trad = function (t) {
      var cambia = false;
      var r = t.split(' / ').map(function (x) {
        var k = x.trim().replace(/,$/, '');   /* en el carrito llega como «Black, » */
        if (ES.hasOwnProperty(k)) { cambia = true; return x.replace(k, ES[k]); }
        return x;
      }).join(' / ');
      return cambia ? r : null;
    };
    var pasar = function () {
      d.querySelectorAll('main, cart-drawer-component, .sticky-add-to-cart, quick-add-dialog, dialog').forEach(function (zona) {
        var w = d.createTreeWalker(zona, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) {
          var v = n.nodeValue;
          if (v.length > 40 || !/[A-Z]/.test(v) || /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName)) continue;
          var t = trad(v); if (t) n.nodeValue = t;
        }
      });
    };
    var cita = 0;
    pasar();
    new MutationObserver(function () { clearTimeout(cita); cita = setTimeout(pasar, 60); })
      .observe(d.body, { childList: true, subtree: true, characterData: true });
  }

  function init() { reveal(); motion(); whatsapp(); barraCompra(); notaCarrito(); colaEliminar(); coloresES(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
